/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Vs_Who_Fc_2Inputs */

const en_fc_vs_who_fc_2 = /** @type {(inputs: Fc_Vs_Who_Fc_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`edit on Linux or want an editor you can run in a browser`)
};

/**
* | output |
* | --- |
* | "edit on Linux or want an editor you can run in a browser" |
*
* @param {Fc_Vs_Who_Fc_2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_who_fc_2 = /** @type {((inputs?: Fc_Vs_Who_Fc_2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_Who_Fc_2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_who_fc_2(inputs)
});
export { fc_vs_who_fc_2 as "fc.vs.who.fc.2" }